import * as React from "react";
import { Box, ListItemText, Typography, ListItemButton, List, ListItem } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import withRouter from "components/withRouter";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        marginTop: "10px",
        borderRadius: "10px",
        display: "flex",
        justifyContent: "space-between",
        paddingLeft: "16px",
        paddingRight: "16px",
        border: "1px solid #EFEFEF",
        backgroundColor: "rgba(255, 255, 255, 0.5)",
        alignItems: "center",
        height: "62px",
        width: "100%",
      }}
    >
      {/* Left Side Text */}
      <Typography variant="body2" color="text.secondary">
        &copy; RegTech ♥ crafted by Team Maven!
      </Typography>

      {/* Right Side List */}
      <List sx={{ display: "flex" }} disablePadding>
        {["Support", "License", "Terms of Use", "Blog"].map((text) => (
          <ListItem key={text} disablePadding sx={{ width: "auto" }}>
            <ListItemButton component="a" href="#simple-list" sx={{ padding: "0 8px" }}>
              <FiberManualRecordIcon sx={{ fontSize: "10px", marginRight: "4px" }} />
              <ListItemText primary={text} primaryTypographyProps={{ variant: "body2" }} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default withRouter(Footer);
